import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import About from './pages/About';
import MissionVision from './pages/MissionVision';
import Products from './pages/Products';
import Portfolio from './pages/Portfolio';
import ProjectVideos from './pages/ProjectVideos';
import Contact from './pages/Contact';

/* ── Placeholder for pages not yet built ── */
function ComingSoon({ title }) {
  return (
    <div style={{
      minHeight: '60vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      paddingTop: '140px', gap: '16px', fontFamily: 'sans-serif',
    }}>
      <h1 style={{ fontSize: '2rem', color: '#1e1e1f' }}>{title}</h1>
      <p style={{ color: '#888' }}>Page coming soon.</p>
    </div>
  );
}

const withLayout = (Component, props = {}) => (
  <>
    <Navbar />
    <Component {...props} />
    <Footer />
  </>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ── Public routes ── */}
        <Route path="/"               element={withLayout(Home)} />
        <Route path="/about"          element={withLayout(About)} />
        <Route path="/mission-vision" element={withLayout(MissionVision)} />
        <Route path="/services"       element={withLayout(Services)} />
        <Route path="/services/:slug" element={withLayout(ServiceDetail)} />

        {/* Projects parent (optional landing) */}
        <Route path="/projects" element={withLayout(ComingSoon, { title: 'Projects' })} />

        {/* Dropdown children */}
        <Route path="/portfolio"       element={withLayout(Portfolio)} />
        <Route path="/products"        element={withLayout(Products)} />
        <Route path="/project-videos"  element={withLayout(ProjectVideos)} />

        {/* Other nav links */}
        <Route path="/team"    element={withLayout(ComingSoon, { title: 'Our Team' })} />
        <Route path="/contact" element={withLayout(Contact)} />

      </Routes>
    </BrowserRouter>
  );
}